const isSetEqual = (a, b) => {
  if (a === b) return true;
  if (a.size !== b.size) return false;
  for (var a of a) if (!b.has(a)) return false;
  return true;
};

export default isSetEqual;
